import { motion } from "framer-motion";
import { WhatsappLogo, ArrowRight, Sparkle, ShieldCheck, Timer, Medal } from "@phosphor-icons/react";
import { IMAGES, WHATSAPP_QUOTE_URL } from "@/data/site";

const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[88vh] flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `url(${IMAGES.hero})`,
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-[#234D89]/95 via-[#234D89]/90 to-[#234D89]/80" />

      <div className="relative z-10 container-custom text-center text-white py-20 pt-32">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.span
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3 }}
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-white mb-6 bg-[#E73336] px-5 py-2.5 rounded-full shadow-lg"
          >
            <Sparkle weight="fill" size={16} />
            Excelência em Acabamentos
            <Sparkle weight="fill" size={16} />
          </motion.span>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight mb-6 max-w-4xl mx-auto leading-[1.15]">
            Acabamentos gráficos que{" "}
            <span className="text-[#E73336] relative">
              valorizam
              <svg className="absolute -bottom-2 left-0 w-full" viewBox="0 0 200 8" fill="none">
                <path d="M1 5.5C47.5 2.5 154 1 199 5.5" stroke="#E73336" strokeWidth="3" strokeLinecap="round"/>
              </svg>
            </span>{" "}
            seu material
          </h1>

          <p className="text-base sm:text-lg lg:text-xl text-white/90 mb-12 max-w-2xl mx-auto leading-relaxed font-light">
            Desde 2008 entregando <strong className="text-white font-semibold">qualidade</strong>, <strong className="text-white font-semibold">precisão</strong> e <strong className="text-white font-semibold">pontualidade</strong> que impressionam seus clientes.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <motion.a
              href={WHATSAPP_QUOTE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-whatsapp"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              className="group inline-flex items-center justify-center gap-3 px-10 py-5 bg-[#E73336] text-white font-bold text-base uppercase tracking-wide rounded-full hover:bg-[#BD2A2C] transition-all shadow-xl shadow-[#E73336]/30 hover:shadow-2xl hover:shadow-[#E73336]/40"
            >
              <WhatsappLogo weight="fill" size={26} className="group-hover:animate-pulse" />
              Quero meu Orçamento
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </motion.a>

            <motion.a
              href="#servicos"
              data-testid="hero-cta-services"
              whileHover={{ scale: 1.02 }}
              className="inline-flex items-center justify-center gap-2 px-8 py-5 bg-white/10 backdrop-blur-sm text-white font-bold text-sm uppercase tracking-wide rounded-full hover:bg-white/20 transition-all border border-white/20"
            >
              Conhecer Serviços
              <ArrowRight size={20} />
            </motion.a>
          </div>

          {/* Trust badges */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8 }}
            className="flex flex-wrap justify-center gap-8 mt-16 pt-8 border-t border-white/10"
          >
            <div className="flex items-center gap-2 text-white/70">
              <ShieldCheck size={20} weight="fill" className="text-[#E73336]" />
              <span className="text-sm">Qualidade Garantida</span>
            </div>
            <div className="flex items-center gap-2 text-white/70">
              <Timer size={20} weight="fill" className="text-[#E73336]" />
              <span className="text-sm">Entrega no Prazo</span>
            </div>
            <div className="flex items-center gap-2 text-white/70">
              <Medal size={20} weight="fill" className="text-[#E73336]" />
              <span className="text-sm">Tradição e Experiência</span>
            </div>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2">
          <motion.div
            animate={{ y: [0, 12, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="w-1.5 h-1.5 bg-white rounded-full"
          />
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
